export default "__VITE_ASSET__BYDQgI8V__"